export default __webpack_public_path__ + "static/whatsapp-logo-8d880b3474d1658d0a33b9c8048a6b6f.svg";